import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Siempre empezaba rutinas y abandonaba a la semana. Con Entrena en Casa pude mantenerme constante por primera vez. Hoy tengo más energía, bajé varios kilos y me siento muchísimo más seguro.',
  name: 'Nicolás M.',
  location: 'Buenos Aires — Entrena desde casa',
  title: 'Volví a sentirme bien conmigo mismo'
}, {
  quote: 'No es solo ejercicio. Cambió mi mentalidad completamente. Ahora tengo hábitos mucho más saludables y ya no me siento agotada todo el tiempo.',
  name: 'Camila R.',
  location: 'Córdoba — Alumna de Entrena en Casa',
  title: 'Me ayudó a crear disciplina de verdad'
}, {
  quote: 'Trabajo todo el día y no tenía tiempo para ir al gimnasio. Este sistema me ayudó a organizarme y entrenar desde mi casa sin complicarme.',
  name: 'Matías F.',
  location: 'Rosario — Usuario del programa',
  title: 'Perfecto para personas ocupadas'
}];
export function Testimonials() {
  return <section className="py-20 px-4 bg-dark" data-id="element-175">
      <div className="max-w-6xl mx-auto" data-id="element-176">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-177">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-dark-card border border-dark-border p-8 rounded-2xl relative" data-id="element-178">
              <div className="flex gap-1 mb-4" data-id="element-179">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-brand text-brand" data-id="element-180" />)}
              </div>
              <h3 className="font-display text-xl text-white mb-4 uppercase tracking-wide" data-id="element-181">
                "{t.title}"
              </h3>
              <p className="text-gray-400 mb-6 italic leading-relaxed" data-id="element-182">
                "{t.quote}"
              </p>
              <div className="mt-auto pt-6 border-t border-dark-border" data-id="element-183">
                <p className="font-bold text-white" data-id="element-184">{t.name}</p>
                <p className="text-sm text-brand" data-id="element-185">{t.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}